/**
 * How long a password must be, in one place.
 *
 * IN `shared/` because a form told somebody 「8文字以上」 while the server refused
 * anything under twelve - the number lived in server/lib/password.ts and the
 * placeholder was typed by hand. A rule the screen states differently from the
 * rule it is checked against is worse than no hint at all: the person types
 * eight characters, is refused, and has no way to know by how much.
 *
 * Length is the only rule. Composition requirements ("one symbol, one digit")
 * measurably push people toward Passw0rd! and away from passphrases, which is
 * why NIST 800-63B dropped them.
 */
export const MIN_PASSWORD_LENGTH = 12;

/** Bounded so a huge body cannot turn one login into a CPU exhaustion attack. */
export const MAX_PASSWORD_LENGTH = 200;

/** The hint a form shows beside a password box. */
export const PASSWORD_HINT = `${MIN_PASSWORD_LENGTH}文字以上`;
